<script src="./CustomSpinner.js"></script>
<style lang="scss" src="./CustomSpinner.scss"></style>

<template>
    <div class="custom-spinner">
        <div class="loading"></div>
    </div>
</template>